module.exports = __webpack_public_path__ + "static/media/poi-logo.9319c5fd.svg";